export { Tabs } from './Tabs';
export type { TabsRules } from './Tabs';
